/* eslint-disable quote-props */
const {default: createMapParams} = require('./createMapParams');

// TODO: add params in order
//  for each route once starting using useRouter
const routeToOF2Page = {
    details: {
        params: [],
    },
    detailsloading: {
        params: [],
    },
    'fare-rules': {
        params: ['bookingId'],
    },
    passengersinfo: {
        params: [],
    },
    payment: {
        params: [],
    },
    test: {
        params: [],
    },
    flightinfo: {
        params: [],
    },
    checkinMicroFunnel: {
        params: [],
    },
    dpresults_accommodation: {
        params: [],
    },
    dpresults_flights: {
        params: [],
    },
    dpresults_accommodation_details: {
        params: [],
    },
    accommodation_details: {
        params: [],
    },
    refundstatusOF2: {
        params: [],
    },
    tripdetails: {
        params: [],
    },
    membership: {
        params: [],
    },
    tripdetails_booking_status: {
        params: ['token'],
    },
    checkout_passengers: {
        params: ['bookingId'],
    },
    checkout_payment: {
        params: ['bookingId'],
    },
    payment_form: {
        params: ['shoppingId'],
    },
    confirm_booking: {
        params: ['bookingId'],
    },
    checkout_flight_summary: {
        params: ['bookingId'],
    },
    checkout_flight_summary_results: {
        params: ['searchParams'],
    },
    checkout_flight_summary_meta: {
        params: ['token'],
    },
    pfhome: {
        params: ['searchId', 'fareItineraryKey', 'segmentKeys'],
    },
    pfoffers: {
        params: ['searchId', 'fareItineraryKey', 'segmentKeys', 'shoppingId'],
    },
    pfpax: {
        params: ['searchId', 'fareItineraryKey', 'segmentKeys'],
    },
    pfpayment: {
        params: ['searchId', 'fareItineraryKey', 'segmentKeys', 'shoppingId'],
    },
    pfconfirmation: {
        params: ['searchId', 'fareItineraryKey', 'segmentKeys'],
    },
    sahome: {
        params: ['token'],
    },
    babilling_details: {
        params: ['token'],
    },
    barequest_invoice: {
        params: ['token'],
    },
    baconfirmation: {
        params: ['token'],
    },
    'manage-my-booking': {},
    categories: {},
    contact: {},
    'help-deflection': {},
    article: {},
    'full-article': {},
    chat: {},
    chatbot: {},
    'native-autocheckin': {},
    'native-managemybooking': {},
    'native-refundstatus': {},
    btform: {},
    cnxflightselector: {},
    cnxpaxselector: {},
    cnxsummary: {},
    cnxconfirmation: {
        params: ['token'],
    },
    cnxinfo: {
        params: ['token'],
    },
    cnx_refund_options: {
        params: ['token'],
    },
    cnxrefund: {
        params: ['token'],
    },
    cnx_confirmation_c4ar: {
        params: ['token'],
    },
    cnxlcc_flightselector: {},
    cnxslcc_stopovers: {},
    cnxlcc_summary: {},
    cnxlcc_steps: {},
    exit: {},
    modifylc_your_flights: {},
    modifylc_your_stopovers: {},
    modifylc_change_trip: {},
    modifylc_steps_by_step: {},
    modify_flightselector: {
        params: ['token'],
    },
    modify_paxselector: {
        params: ['token'],
    },
    modify_search: {
        params: ['token'],
    },
    modify_calendar: {
        params: ['token'],
    },
    modify_results: {
        params: ['token'],
    },
    modify_itinerary: {
        params: ['token'],
    },
    modify_summary: {
        params: ['token'],
    },
    modify_confirmation: {
        params: ['token'],
    },
    alt_intro: {
        params: ['token'],
    },
    alt_hub: {
        params: ['token'],
    },
    alt_refund: {
        params: ['token'],
    },
    alt_search: {
        params: ['token'],
    },
    alt_calendar: {
        params: ['token'],
    },
    alt_results: {
        params: ['token'],
    },
    alt_confirmation: {
        params: ['token'],
    },
    alt_contact: {
        params: ['token'],
    },
    alt_details: {
        params: ['token'],
    },
    alt_summary: {
        params: ['token'],
    },
    mytripslogin: {
        params: [],
    },
    mytrips: {
        params: [],
    },
    unavailablecheckin: {
        params: ['token'],
    },
    non_essential_products: {
        params: ['category', 'shoppingId'],
    },
    'non_essential_products/disruption_compensation': {
        params: ['bookingId'],
    },
    canx: {
        params: ['bookingId'],
    },
    insurances: {
        params: ['bookingId'],
    },
    flex_dates: {
        params: ['bookingId'],
    },
    support_pack: {
        params: ['bookingId'],
    },
    checkout_ancillaries: {
        params: ['bookingId'],
    },
    checkout_prime_subscription: {
        params: ['bookingId'],
    },
    checkout_flash_offer: {
        params: ['bookingId'],
    },
    additions: {
        params: ['bookingId'],
    },
    disruption_compensation: {
        params: ['bookingId'],
    },
    flexibility_bundle: {
        params: ['bookingId'],
    },
    booking: {
        /**
         * @deprecated page key has been deprecated
         */
        page: 'dpresults_trips_summary',
        params: [],
    },
    accountpreferences: {
        params: [],
    },
    accountcreditcards: {
        params: [],
    },
    first_login: {
        params: [],
    },
    confirmation: {
        params: [],
    },
    post_booking: {
        params: [],
    },
    bp_results: {
        params: [],
    },
    membership_postbooking: {
        params: ['bookingParams'],
    },
    standalone_campaign: {
        params: ['campaignParams'],
    },
    standalone_checkout: {
        params: ['shoppingBasketID'],
    },
    standalone_confirmation: {
        params: ['shoppingBasketID'],
    },
    membership_retention: {
        params: [],
    },
    membership_cancellation: {
        params: [],
    },
    membership_cancellation_request: {
        params: [],
    },
    membership_mytrips_reactivation: {
        params: [],
    },
    membership_page: {
        params: ['bookingId'],
    },
    membership_referral: {
        params: ['referralParams'],
    },
    membership_referral_invite_friends: {
        params: ['referralParams'],
    },
    membership_referral_invite_recommendations: {
        params: ['referralParams'],
    },
    extras_checkin_funnel_v2_info: {
        params: ['token'],
    },
    extras_checkin_funnel_v2_upsell_fasttrack: {
        params: ['token', 'shoppingId'],
    },
    extras_checkin_funnel_v2_upsell_seats: {
        params: ['token', 'shoppingId'],
    },
    extras_checkin_funnel_v2_form: {
        params: ['token'],
    },
    extras_checkin_funnel_v2_confirmation_success: {
        params: ['token'],
    },
    extras_fast_track: {
        params: ['token'],
    },
    extras_baggage_protection: {
        params: ['token'],
    },
    extras_post_booking_seats: {
        params: ['token'],
    },
    extras_post_booking_bags: {
        params: ['token'],
    },
    paybylink_validation: {
        params: ['membershipId'],
    },
    paybylink_content_validation: {
        params: ['payByLinkContentId', 'scenarioId'],
    },
    add_payment_method: {
        params: ['crmToken'],
    },
    add_payment_method_confirmation: {
        params: ['shoppingBasketId', 'operationResult'],
    },
    shopping_basket_checkout: {
        params: ['shoppingId', 'onSuccessUrl'],
    },
    passwordless_login: {
        params: [],
    },
    ancillaries: {
        params: [],
    },
    'user-register': {
        params: [],
    },
    user_area: {
        params: [],
    },
    user_membership: {
        params: [],
    },
    payment_methods: {
        params: [],
    },
    login_and_security: {
        params: [],
    },
    reset_password: {
        params: [],
    },
    trip_list: {
        params: [],
    },
    managemybooking: {
        params: [],
    },
    booking_cancellation_confirmation: {
        params: ['primeFreeCancellationParams'],
    },
    booking_cancellation_error: {
        params: ['primeFreeCancellationParams'],
    },
    booking_cancellation_trip_management: {
        params: ['primeFreeCancellationParams'],
    },
};

/**
 * @param {object} frontendShell
 * @param {string} route
 * @param {undefined|string[]=} paramsValues
 */
const navigate = (frontendShell, route, paramsValues) => {
    if (routeToOF2Page[route]) {
        const {params: paramsNames, page: deprecatedPage} = routeToOF2Page[route];
        frontendShell.execute(({page}) => {
            page.navigate(deprecatedPage ? deprecatedPage : route, createMapParams(paramsNames, paramsValues));
        });
    }
};

module.exports = navigate;
